export default __webpack_public_path__ + "static/media/Carlos.c8e10166.png";